export default {
  SET_COMMENTS(state, comments) {
    state.comments = comments
  },

  resetComments(state) {
    state.comments = []
  },
}
